const NoScope = () => 'N/A';

export default NoScope;
